module.exports = __webpack_public_path__ + "assets/images/client-6.9025107e.jpeg";